//===================== utility ==============================
export const SET_LOGGED_IN = "SET_LOGGED_IN";
export const UNSET_LOGGED_IN = "UNSET_LOGGED_IN";
export const SET_MESSAGE = "SET_MESSAGE";
export const UNSET_MESSAGE = "UNSET_MESSAGE";
export const SET_SNACKBAR = "SET_SNACKBAR";
export const UNSET_SNACKBAR = "UNSET_SNACKBAR";
export const SET_LOADING = "SET_LOADING";
export const UNSET_LOADING = "UNSET_LOADING";
export const SET_LOADING_COLOR = "SET_LOADING_COLOR";
export const UNSET_LOADING_COLOR = "UNSET_LOADING_COLOR";
export const SET_NOTIFICATION = "SET_NOTIFICATION";
export const SET_FORMNOTIFY = "SET_FORMNOTIFY";
export const UNSET_FORMNOTIFY = "UNSET_FORMNOTIFY";
//===================== users login/logout ==============================
export const SET_USER_LOGGED_IN = "SET_USER_LOGGED_IN";
export const UNSET_USER_LOGGED_IN = "UNSET_USER_LOGGED_IN";
export const SET_USER_TOKEN = "SET_USER_TOKEN";
export const UNSET_USER_TOKEN = "UNSET_USER_TOKEN";
export const SET_AUTH_USER = "SET_AUTH_USER";
export const UNSET_AUTH_USER = "UNSET_AUTH_USER";
export const SET_USER_PERMISSION = "SET_USER_PERMISSION";
export const UNSET_USER_PERMISSION = "UNSET_USER_PERMISSION";


//===================== User Message ==============================
export const SET_USER_MESSAGE = "SET_USER_MESSAGE";
export const UNSET_USER_MESSAGE = "UNSET_USER_MESSAGE";

//===================== layout Admin ==============================
export const SET_SIDEBAR_COLLAPSE = "SET_SIDEBAR_COLLAPSE";
export const UNSET_SIDEBAR_COLLAPSE = "UNSET_SIDEBAR_COLLAPSE";

//===================== Administration Module ==============================
// Company List
export const SET_COMPANY_LIST = "SET_COMPANY_LIST";
export const UNSET_COMPANY_LIST = "UNSET_COMPANY_LIST";
export const SET_CURRENT_COMPANY = "SET_CURRENT_COMPANY";
export const UNSET_CURRENT_COMPANY = "UNSET_CURRENT_COMPANY";
// Branch List
export const SET_BRANCH_LIST = "SET_BRANCH_LIST";
export const UNSET_BRANCH_LIST = "UNSET_BRANCH_LIST";
export const SET_ALL_BRANCH_LIST = "SET_ALL_BRANCH_LIST";
export const UNSET_ALL_BRANCH_LIST = "UNSET_ALL_BRANCH_LIST";
export const SET_CURRENT_BRANCH = "SET_CURRENT_BRANCH";
export const UNSET_CURRENT_BRANCH = "UNSET_CURRENT_BRANCH";
// Company Module List
export const SET_COMPANY_MODULE_LIST = "SET_COMPANY_MODULE_LIST";
export const UNSET_COMPANY_MODULE_LIST = "UNSET_COMPANY_MODULE_LIST";
export const SET_TEMP_COMPANY_MODULE_LIST = "SET_TEMP_COMPANY_MODULE_LIST";
export const UNSET_TEMP_COMPANY_MODULE_LIST = "UNSET_TEMP_COMPANY_MODULE_LIST";

// Branch Module List
export const SET_BRANCH_MODULE_LIST = "SET_BRANCH_MODULE_LIST";
export const UNSET_BRANCH_MODULE_LIST = "UNSET_BRANCH_MODULE_LIST";
export const SET_BRANCH_WISE_MODULE_LIST = "SET_BRANCH_WISE_MODULE_LIST";
export const UNSET_BRANCH_WISE_MODULE_LIST = "UNSET_BRANCH_WISE_MODULE_LIST";
export const SET_TEMP_BRANCH_MODULE_LIST = "SET_TEMP_BRANCH_MODULE_LIST";
export const UNSET_TEMP_BRANCH_MODULE_LIST = "UNSET_TEMP_BRANCH_MODULE_LIST";

// User List
export const SET_USERS_LIST = "SET_USERS_LIST";
export const UNSET_USERS_LIST = "UNSET_USERS_LIST";
// Module
export const SET_MODULE_LIST = "SET_MODULE_LIST";
export const UNSET_MODULE_LIST = "UNSET_MODULE_LIST";
// Sub Module
export const SET_SUB_MODULE_LIST = "SET_SUB_MODULE_LIST";
export const UNSET_SUB_MODULE_LIST = "UNSET_SUB_MODULE_LIST";
// Menu
export const SET_MENU_LIST = "SET_MENU_LIST";
export const UNSET_MENU_LIST = "UNSET_MENU_LIST";
// Role 
export const SET_ROLE_LIST = "SET_ROLE_LIST";
export const UNSET_ROLE_LIST = "UNSET_ROLE_LIST";
export const SET_MODULE_BY_BRANCH = "SET_MODULE_BY_BRANCH";
export const UNSET_MODULE_BY_BRANCH = "UNSET_MODULE_BY_BRANCH";
// Role Permission
export const SET_ROLE_PERMISSION = "SET_ROLE_PERMISSION";
export const UNSET_ROLE_PERMISSION = "UNSET_ROLE_PERMISSION";
// Approval Management
export const SET_APPROVAL_NAME_LIST = "SET_APPROVAL_NAME_LIST";
export const UNSET_APPROVAL_NAME_LIST = "UNSET_APPROVAL_NAME_LIST";
export const SET_APPROVAL_MATRIX_LIST = "SET_APPROVAL_MATRIX_LIST";
export const UNSET_APPROVAL_MATRIX_LIST = "UNSET_APPROVAL_MATRIX_LIST";
export const SET_APPROVAL_STEP_NAMES = "SET_APPROVAL_STEP_NAMES";
export const UNSET_APPROVAL_STEP_NAMES = "UNSET_APPROVAL_STEP_NAMES";

//===================== Inventory Module ==============================
// Warehouse 
export const SET_WAREHOUSE_LIST = "SET_WAREHOUSE_LIST";
export const UNSET_WAREHOUSE_LIST = "UNSET_WAREHOUSE_LIST";
// Brand 
export const SET_BRAND_LIST = "SET_BRAND_LIST";
export const UNSET_BRAND_LIST = "UNSET_BRAND_LIST";
// Brand 
export const SET_MANUFACTURE_LIST = "SET_MANUFACTURE_LIST";
export const UNSET_MANUFACTURE_LIST = "UNSET_MANUFACTURE_LIST";
export const SET_CURRENT_MANUFACTURE = "SET_CURRENT_MANUFACTURE";
export const UNSET_CURRENT_MANUFACTURE = "UNSET_CURRENT_MANUFACTURE";
// Unit 
export const SET_UNIT_LIST = "SET_UNIT_LIST";
export const UNSET_UNIT_LIST = "UNSET_UNIT_LIST";
 
// Secondary Unit
export const SET_SECONDARY_UNIT_LIST = "SET_SECONDARY_UNIT_LIST";
export const UNSET_SECONDARY_UNIT_LIST = "UNSET_SECONDARY_UNIT_LIST";

// Product Type 
export const SET_PRODUCT_TYPE_LIST = "SET_PRODUCT_TYPE_LIST";
export const UNSET_PRODUCT_TYPE_LIST = "UNSET_PRODUCT_TYPE_LIST";
// Size 
export const SET_SIZE_LIST = "SET_SIZE_LIST";
export const UNSET_SIZE_LIST = "UNSET_SIZE_LIST";
// Category
export const SET_CATEGORY_LIST = "SET_CATEGORY_LIST";
export const UNSET_CATEGORY_LIST = "UNSET_CATEGORY_LIST";
// Sub Category
export const SET_SUB_CATEGORY_LIST = "SET_SUB_CATEGORY_LIST";
export const UNSET_SUB_CATEGORY_LIST = "UNSET_SUB_CATEGORY_LIST";
// Product 
export const SET_PRODUCT_LIST = "SET_PRODUCT_LIST";
export const UNSET_PRODUCT_LIST = "UNSET_PRODUCT_LIST";
export const SET_PRODUCT_CSV = "SET_PRODUCT_CSV";
export const UNSET_PRODUCT_CSV = "UNSET_PRODUCT_CSV";

// Product Mapping
export const SET_PRODUCT_MAP_LIST = "SET_PRODUCT_MAP_LIST";
export const UNSET_PRODUCT_MAP_LIST = "UNSET_PRODUCT_MAP_LIST";

// Supplier Type
export const SET_SUPPLIER_TYPE_LIST = "SET_SUPPLIER_TYPE_LIST";
export const UNSET_SUPPLIER_TYPE_LIST = "UNSET_SUPPLIER_TYPE_LIST";
// Supplier
export const SET_SUPPLIER_LIST = "SET_SUPPLIER_LIST";
export const UNSET_SUPPLIER_LIST = "UNSET_SUPPLIER_LIST";
// Supplier Mapping
export const SET_SUPPLIER_MAP_LIST = "SET_SUPPLIER_MAP_LIST";
export const UNSET_SUPPLIER_MAP_LIST = "UNSET_SUPPLIER_MAP_LIST";

// Direct Receive
export const SET_INV_DIRECT_RECEIVE_LIST = "SET_INV_DIRECT_RECEIVE_LIST";
export const UNSET_INV_DIRECT_RECEIVE_LIST = "UNSET_INV_DIRECT_RECEIVE_LIST";
// PO Receive
export const SET_INV_PO_RECEIVE_LIST = "SET_INV_PO_RECEIVE_LIST";
export const UNSET_INV_PO_RECEIVE_LIST = "UNSET_INV_PO_RECEIVE_LIST";
export const SET_RECEIVED_PO_LIST = "SET_RECEIVED_PO_LIST";
export const UNSET_RECEIVED_PO_LIST = "UNSET_RECEIVED_PO_LIST";

// LC Receive
export const SET_INV_LC_RECEIVE_LIST = "SET_INV_LC_RECEIVE_LIST";
export const UNSET_INV_LC_RECEIVE_LIST = "UNSET_INV_LC_RECEIVE_LIST";

// Return
export const SET_PURCHASE_RETURN_LIST = "SET_PURCHASE_RETURN_LIST";
export const UNSET_PURCHASE_RETURN_LIST = "UNSET_PURCHASE_RETURN_LIST";
export const SET_PURCHASE_RETURN_DETAILS = "SET_PURCHASE_RETURN_DETAILS";
export const UNSET_PURCHASE_RETURN_DETAILS = "UNSET_PURCHASE_RETURN_DETAILS";

export const SET_SALES_RETURN_LIST = "SET_SALES_RETURN_LIST";
export const UNSET_SALES_RETURN_LIST = "UNSET_SALES_RETURN_LIST";
export const SET_SALES_RETURN_DETAILS = "SET_SALES_RETURN_DETAILS";
export const UNSET_SALES_RETURN_DETAILS = "UNSET_SALES_RETURN_DETAILS";

// Item Transfer
export const SET_INV_ITEM_TRANSFER_LIST = "SET_INV_ITEM_TRANSFER_LIST";
export const UNSET_INV_ITEM_TRANSFER_LIST = "UNSET_INV_ITEM_TRANSFER_LIST";

// Inventory Records
export const SET_INVENTORY_RECORDS_LIST = "SET_INVENTORY_RECORDS_LIST";
export const UNSET_INVENTORY_RECORDS_LIST = "UNSET_INVENTORY_RECORDS_LIST";

// Inventory Details
export const SET_INVENTORY_DETAILS_LIST = "SET_INVENTORY_DETAILS_LIST";
export const UNSET_INVENTORY_DETAILS_LIST = "UNSET_INVENTORY_DETAILS_LIST";
export const SET_INVENTORY_BATCH_LIST = "SET_INVENTORY_BATCH_LIST";
export const UNSET_INVENTORY_BATCH_LIST = "UNSET_INVENTORY_BATCH_LIST";

//===================== Inventory Requisition ==============================
export const SET_INV_REQUISITION_LIST = "SET_INV_REQUISITION_LIST";
export const UNSET_INV_REQUISITION_LIST = "UNSET_INV_REQUISITION_LIST";
export const SET_INV_DUE_REQUISITION_LIST = "SET_INV_DUE_REQUISITION_LIST";
export const UNSET_INV_DUE_REQUISITION_LIST = "UNSET_INV_DUE_REQUISITION_LIST";

// Inv Issue management
export const SET_INV_ISSUE_LIST = "SET_INV_ISSUE_LIST";
export const UNSET_INV_ISSUE_LIST = "UNSET_INV_ISSUE_LIST";

// Inv Requisition Delivery Management
export const SET_INV_REQUISITION_DELIVERY_LIST = "SET_INV_REQUISITION_DELIVERY_LIST";
export const UNSET_INV_REQUISITION_DELIVERY_LIST = "UNSET_INV_REQUISITION_DELIVERY_LIST";
export const SET_EDITING_INV_REQUISITION_DELIVERY_LIST = "SET_EDITING_INV_REQUISITION_DELIVERY_LIST";
export const UNSET_EDITING_INV_REQUISITION_DELIVERY_LIST = "UNSET_EDITING_INV_REQUISITION_DELIVERY_LIST";

// Inv Sales Invoice Delivery Management
export const SET_INV_SALES_INVOICE_DELIVERY_LIST = "SET_INV_SALES_INVOICE_DELIVERY_LIST";
export const UNSET_INV_SALES_INVOICE_DELIVERY_LIST = "UNSET_INV_SALES_INVOICE_DELIVERY_LIST";
export const SET_EDITING_INV_SALES_INVOICE_DELIVERY_LIST = "SET_EDITING_INV_SALES_INVOICE_DELIVERY_LIST";
export const UNSET_EDITING_INV_SALES_INVOICE_DELIVERY_LIST = "UNSET_EDITING_INV_SALES_INVOICE_DELIVERY_LIST";
export const SET_INV_DELIVERED_SALES_INVOICE_LIST = "SET_INV_DELIVERED_SALES_INVOICE_LIST";
export const UNSET_INV_DELIVERED_SALES_INVOICE_LIST = "UNSET_INV_DELIVERED_SALES_INVOICE_LIST";
// Inv Gate Pass
export const SET_INV_GATE_PASS_LIST = "SET_INV_GATE_PASS_LIST";
export const UNSET_INV_GATE_PASS_LIST = "UNSET_INV_GATE_PASS_LIST";
export const SET_EDITING_INV_GATE_PASS_LIST = "SET_EDITING_INV_GATE_PASS_LIST";
export const UNSET_EDITING_INV_GATE_PASS_LIST = "UNSET_EDITING_INV_GATE_PASS_LIST";

// Inv Country Management
export const SET_INV_COUNTRY_LIST = "SET_INV_COUNTRY_LIST";
export const UNSET_INV_COUNTRY_LIST = "UNSET_INV_COUNTRY_LIST";

// Location Management
export const SET_DIVISION_LIST = "SET_DIVISION_LIST";
export const UNSET_DIVISION_LIST = "UNSET_DIVISION_LIST";
export const SET_DISTRICT_LIST = "SET_DISTRICT_LIST";
export const UNSET_DISTRICT_LIST = "UNSET_DISTRICT_LIST";
export const SET_UPAZILA_LIST = "SET_UPAZILA_LIST";
export const UNSET_UPAZILA_LIST = "UNSET_UPAZILA_LIST";

//-------------------------- Customer Management -----------------------

// Customer Type
export const SET_CUSTOMER_TYPE_LIST = "SET_CUSTOMER_TYPE_LIST";
export const UNSET_CUSTOMER_TYPE_LIST = "UNSET_CUSTOMER_TYPE_LIST";
// Customer
export const SET_CUSTOMER_LIST = "SET_CUSTOMER_LIST";
export const UNSET_CUSTOMER_LIST = "UNSET_CUSTOMER_LIST";
// Customer Mapping
export const SET_CUSTOMER_MAP_LIST = "SET_CUSTOMER_MAP_LIST";
export const UNSET_CUSTOMER_MAP_LIST = "UNSET_CUSTOMER_MAP_LIST";

//===================== HRM Module ==============================

// Letter Setup
export const SET_HRM_LETTER_INFO_LIST = "SET_HRM_LETTER_INFO_LIST";
export const UNSET_HRM_LETTER_INFO_LIST = "UNSET_HRM_LETTER_INFO_LIST";

//Department
export const SET_HRM_DEPARTMENT_LIST = "SET_HRM_DEPARTMENT_LIST";
export const UNSET_HRM_DEPARTMENT_LIST = "UNSET_HRM_DEPARTMENT_LIST";
//Section
export const SET_HRM_SECTION_LIST = "SET_HRM_SECTION_LIST";
export const UNSET_HRM_SECTION_LIST = "UNSET_HRM_SECTION_LIST";
//Designation
export const SET_HRM_DESIGNATION_LIST = "SET_HRM_DESIGNATION_LIST";
export const UNSET_HRM_DESIGNATION_LIST = "UNSET_HRM_DESIGNATION_LIST";
//Employee Type
export const SET_HRM_EMPLOYEE_TYPE_LIST = "SET_HRM_EMPLOYEE_TYPE_LIST";
export const UNSET_HRM_EMPLOYEE_TYPE_LIST = "UNSET_HRM_EMPLOYEE_TYPE_LIST";
//Blood Group
export const SET_HRM_BLOOD_GROUP_TYPE_LIST = "SET_HRM_BLOOD_GROUP_TYPE_LIST";
export const UNSET_HRM_BLOOD_GROUP_TYPE_LIST = "UNSET_HRM_BLOOD_GROUP_TYPE_LIST";
// Gender
export const SET_HRM_GENDER_LIST = "SET_HRM_GENDER_LIST";
export const UNSET_HRM_GENDER_LIST = "UNSET_HRM_GENDER_LIST";
// Religion
export const SET_HRM_RELIGION_LIST = "SET_HRM_RELIGION_LIST";
export const UNSET_HRM_RELIGION_LIST = "UNSET_HRM_RELIGION_LIST";

// Marital Status
export const SET_HRM_MARITAL_STATUS_LIST = "SET_HRM_MARITAL_STATUS_LIST";
export const UNSET_HRM_MARITAL_STATUS_LIST = "UNSET_HRM_MARITAL_STATUS_LIST";

// Employee Bank Setup
export const SET_HRM_EMPLOYEE_BANK_SETUP_LIST = "SET_HRM_EMPLOYEE_BANK_SETUP_LIST";
export const UNSET_HRM_EMPLOYEE_BANK_SETUP_LIST = "UNSET_HRM_EMPLOYEE_BANK_SETUP_LIST";

// Nominee
export const SET_NOMINEE_LIST = "SET_NOMINEE_LIST";
export const UNSET_NOMINEE_LIST = "UNSET_NOMINEE_LIST";

// Increment
export const SET_INCREMENT_LIST = "SET_INCREMENT_LIST";
export const UNSET_INCREMENT_LIST = "UNSET_INCREMENT_LIST";

// Promotion
export const SET_PROMOTION_LIST = "SET_PROMOTION_LIST";
export const UNSET_PROMOTION_LIST = "UNSET_PROMOTION_LIST";

// Claim
export const SET_HRM_CLAIM_LIST = "SET_HRM_CLAIM_LIST";
export const UNSET_HRM_CLAIM_LIST = "UNSET_HRM_CLAIM_LIST";
export const SET_HRM_CLAIM_TYPE_LIST = "SET_HRM_CLAIM_TYPE_LIST";
export const UNSET_HRM_CLAIM_TYPE_LIST = "UNSET_HRM_CLAIM_TYPE_LIST";
export const SET_EDITING_HRM_CLAIM = "SET_EDITING_HRM_CLAIM";
export const UNSET_EDITING_HRM_CLAIM = "UNSET_EDITING_HRM_CLAIM";

// Employee
export const SET_HRM_EMPLOYEE_LIST = "SET_HRM_EMPLOYEE_LIST";
export const UNSET_HRM_EMPLOYEE_LIST = "UNSET_HRM_EMPLOYEE_LIST";
export const SET_EDITING_HRM_EMPLOYEE_LIST = "SET_EDITING_HRM_EMPLOYEE_LIST";
export const UNSET_EDITING_HRM_EMPLOYEE_LIST = "UNSET_EDITING_HRM_EMPLOYEE_LIST";
export const SET_EMPLOYEE_DETAILS = "SET_EMPLOYEE_DETAILS";
export const UNSET_EMPLOYEE_DETAILS = "UNSET_EMPLOYEE_DETAILS";
export const SET_EMPLOYEE_DETAILS_BY_USER = "SET_EMPLOYEE_DETAILS_BY_USER";
export const UNSET_EMPLOYEE_DETAILS_BY_USER = "UNSET_EMPLOYEE_DETAILS_BY_USER";

export const SET_SALARY_INFO_LIST = "SET_SALARY_INFO_LIST";
export const SET_SALARY_INFO_DETAILS = "SET_SALARY_INFO_DETAILS";
export const UNSET_SALARY_INFO_DETAILS = "UNSET_SALARY_INFO_DETAILS";
export const SET_HRM_EMPLOYEE_PERMISSION_WISE_LIST = "SET_HRM_EMPLOYEE_PERMISSION_WISE_LIST";
export const UNSET_HRM_EMPLOYEE_PERMISSION_WISE_LIST = "UNSET_HRM_EMPLOYEE_PERMISSION_WISE_LIST";
export const SET_HRM_TEAM_WISE_EMPLOYEE_LIST = "SET_HRM_TEAM_WISE_EMPLOYEE_LIST";
export const UNSET_HRM_TEAM_WISE_EMPLOYEE_LIST = "UNSET_HRM_TEAM_WISE_EMPLOYEE_LIST";
export const SET_HRM_DEPERTMENT_WISE_EMPLOYEE_LIST = "SET_HRM_DEPERTMENT_WISE_EMPLOYEE_LIST";
export const UNSET_HRM_DEPERTMENT_WISE_EMPLOYEE_LIST = "UNSET_HRM_DEPERTMENT_WISE_EMPLOYEE_LIST";


// Color
export const SET_COLOR_LIST = "SET_COLOR_LIST";
export const UNSET_COLOR_LIST = "UNSET_COLOR_LIST";
// HOD
export const SET_HRM_HOD_LIST = "SET_HRM_HOD_LIST";
export const UNSET_HRM_HOD_LIST = "UNSET_HRM_HOD_LIST";

// Educational Information
export const SET_EDUCATIONAL_INFO_LIST = "SET_EDUCATIONAL_INFO_LIST";
export const UNSET_EDUCATIONAL_INFO_LIST = "UNSET_EDUCATIONAL_INFO_LIST";
export const SET_EDUCATIONAL_INFO_DETAILS = "SET_EDUCATIONAL_INFO_DETAILS";
export const UNSET_EDUCATIONAL_INFO_DETAILS = "UNSET_EDUCATIONAL_INFO_DETAILS";
export const SET_EDUCATIONAL_INFO_LOADING = "SET_EDUCATIONAL_INFO_LOADING";

// Address Information
export const SET_ADDRESS_INFO_LIST = "SET_ADDRESS_INFO_LIST";
export const UNSET_ADDRESS_INFO_LIST = "UNSET_ADDRESS_INFO_LIST";
export const SET_ADDRESS_INFO_DETAILS = "SET_ADDRESS_INFO_DETAILS";
export const UNSET_ADDRESS_INFO_DETAILS = "UNSET_ADDRESS_INFO_DETAILS";

// Previous Employment Information
export const SET_PREVIOUS_EMPLOYMENT_INFO_LIST = "SET_PREVIOUS_EMPLOYMENT_INFO_LIST";
export const UNSET_PREVIOUS_EMPLOYMENT_INFO_LIST = "UNSET_PREVIOUS_EMPLOYMENT_INFO_LIST";
export const SET_PREVIOUS_EMPLOYMENT_INFO_DETAILS = "SET_PREVIOUS_EMPLOYMENT_INFO_DETAILS";
export const UNSET_PREVIOUS_EMPLOYMENT_INFO_DETAILS = "UNSET_PREVIOUS_EMPLOYMENT_INFO_DETAILS";

// Other Information
export const SET_OTHER_INFO_LIST = "SET_OTHER_INFO_LIST";
export const UNSET_OTHER_INFO_LIST = "UNSET_OTHER_INFO_LIST";
export const SET_OTHER_INFO_DETAILS = "SET_OTHER_INFO_DETAILS";
export const UNSET_OTHER_INFO_DETAILS = "UNSET_OTHER_INFO_DETAILS";

// Settings Information
export const SET_SETTINGS_INFO_LIST = "SET_SETTINGS_INFO_LIST";
export const UNSET_SETTINGS_INFO_LIST = "UNSET_SETTINGS_INFO_LIST";
export const SET_SETTINGS_INFO_DETAILS = "SET_SETTINGS_INFO_DETAILS";
export const UNSET_SETTINGS_INFO_DETAILS = "UNSET_SETTINGS_INFO_DETAILS";

// Employee Salary Info
export const SET_EMPLOYEE_SALARY_INFO = "SET_EMPLOYEE_SALARY_INFO";
export const UNSET_EMPLOYEE_SALARY_INFO = "UNSET_EMPLOYEE_SALARY_INFO";

// Office List
export const SET_OFFICE_LIST = "SET_OFFICE_LIST";
export const UNSET_OFFICE_LIST = "UNSET_OFFICE_LIST";

// HRM Reports
export const SET_PROMOTION_REPORT_LIST = "SET_PROMOTION_REPORT_LIST";
export const UNSET_PROMOTION_REPORT_LIST = "UNSET_PROMOTION_REPORT_LIST";
export const SET_NOMINEE_REPORT_LIST = "SET_NOMINEE_REPORT_LIST";
export const UNSET_NOMINEE_REPORT_LIST = "UNSET_NOMINEE_REPORT_LIST";
export const SET_EMPLOYEE_SUMMARY_REPORT_LIST = "SET_EMPLOYEE_SUMMARY_REPORT_LIST";
export const UNSET_EMPLOYEE_SUMMARY_REPORT_LIST = "UNSET_EMPLOYEE_SUMMARY_REPORT_LIST";


//===================== Purchase ==============================
export const SET_PUR_REQUSITION_LIST = "SET_PUR_REQUSITION_LIST";
export const UNSET_PUR_REQUSITION_LIST = "UNSET_PUR_REQUSITION_LIST";
export const SET_SELECTED_PUR_REQUSITION_LIST = "SET_SELECTED_PUR_REQUSITION_LIST";
export const UNSET_SELECTED_PUR_REQUSITION_LIST = "UNSET_SELECTED_PUR_REQUSITION_LIST";
export const SET_ORDERABLE_PUR_REQUSITION_LIST = "SET_ORDERABLE_PUR_REQUSITION_LIST";
export const UNSET_ORDERABLE_PUR_REQUSITION_LIST = "UNSET_ORDERABLE_PUR_REQUSITION_LIST";
export const SET_MERGEABLE_PUR_REQUSITION_LIST = "SET_MERGEABLE_PUR_REQUSITION_LIST";
export const UNSET_MERGEABLE_PUR_REQUSITION_LIST = "UNSET_MERGEABLE_PUR_REQUSITION_LIST";

export const SET_PENDING_PUR_REQUISITION = "SET_PENDING_PUR_REQUISITION";
export const UNSET_PENDING_PUR_REQUISITION = "UNSET_PENDING_PUR_REQUISITION";

export const SET_PUR_REQUSITION_MERGE_LIST = "SET_PUR_REQUSITION_MERGE_LIST";
export const UNSET_PUR_REQUSITION_MERGE_LIST = "UNSET_PUR_REQUSITION_MERGE_LIST";
export const SET_RFQABLE_PUR_REQUSITION_MERGE_LIST = "SET_RFQABLE_PUR_REQUSITION_MERGE_LIST";
export const UNSET_RFQABLE_PUR_REQUSITION_MERGE_LIST = "UNSET_RFQABLE_PUR_REQUSITION_MERGE_LIST";
export const SET_ORDERABLE_PUR_REQUSITION_MERGE_LIST = "SET_ORDERABLE_PUR_REQUSITION_MERGE_LIST";
export const UNSET_ORDERABLE_PUR_REQUSITION_MERGE_LIST = "UNSET_ORDERABLE_PUR_REQUSITION_MERGE_LIST";


export const SET_RFQ_LIST = "SET_RFQ_LIST";
export const UNSET_RFQ_LIST = "UNSET_RFQ_LIST";
export const SET_QUOTATIONABLLE_RFQ_LIST = "SET_QUOTATIONABLLE_RFQ_LIST";
export const UNSET_QUOTATIONABLLE_RFQ_LIST = "UNSET_QUOTATIONABLLE_RFQ_LIST";

//Purchase Settings 
export const SET_LETTER_INFO = "SET_LETTER_INFO";
export const UNSET_LETTER_INFO = "UNSET_LETTER_INFO";

export const SET_CS_QUOTATION_LIST = "SET_CS_QUOTATION_LIST";
export const UNSET_CS_QUOTATION_LIST = "UNSET_CS_QUOTATION_LIST";
export const SET_SELECTED_CS_QUOTATION_LIST = "SET_SELECTED_CS_QUOTATION_LIST";
export const UNSET_SELECTED_CS_QUOTATION_LIST = "UNSET_SELECTED_CS_QUOTATION_LIST";
export const SET_SELECTED_CS_QUOTATION_EVALUATION_LIST = "SET_SELECTED_CS_QUOTATION_EVALUATION_LIST";
export const UNSET_SELECTED_CS_QUOTATION_EVALUATION_LIST = "UNSET_SELECTED_CS_QUOTATION_EVALUATION_LIST";

export const SET_EVALUATION_LIST = "SET_EVALUATION_LIST";
export const UNSET_EVALUATION_LIST = "UNSET_EVALUATION_LIST";
// Purchase Order
export const SET_PUR_ORDER_LIST = "SET_PUR_ORDER_LIST";
export const UNSET_PUR_ORDER_LIST = "UNSET_PUR_ORDER_LIST";
export const SET_PUR_ORDER_BY_ID = "SET_PUR_ORDER_BY_ID";
export const SET_RECEIVABLE_PUR_ORDER_LIST = "SET_RECEIVABLE_PUR_ORDER_LIST";
export const UNSET_RECEIVABLE_PUR_ORDER_LIST = "UNSET_RECEIVABLE_PUR_ORDER_LIST";

export const SET_PUR_INVOICE_LIST = "SET_PUR_INVOICE_LIST";
export const UNSET_PUR_INVOICE_LIST = "UNSET_PUR_INVOICE_LIST";

export const SET_SUPPLIER_PAYMENT_LIST = "SET_SUPPLIER_PAYMENT_LIST";
export const UNSET_SUPPLIER_PAYMENT_LIST = "UNSET_SUPPLIER_PAYMENT_LIST";

export const SET_EVALUATION_PARAM_GENERATE = "SET_EVALUATION_PARAM_GENERATE";
export const UNSET_EVALUATION_PARAM_GENERATE = "UNSET_EVALUATION_PARAM_GENERATE";

export const SET_SELECTED_SUPPLIER_LIST = "SET_SELECTED_SUPPLIER_LIST";
export const UNSET_SELECTED_SUPPLIER_LIST = "UNSET_SELECTED_SUPPLIER_LIST";

//purchase reports
export const SET_PUR_SUPPLIER_LIST_REPORT = "SET_PUR_SUPPLIER_LIST_REPORT";
export const UNSET_PUR_SUPPLIER_LIST_REPORT = "UNSET_PUR_SUPPLIER_LIST_REPORT";

export const SET_PUR_REQUISITION_REPORT = "SET_PUR_REQUISITION_REPORT";
export const UNSET_PUR_REQUISITION_REPORT = "UNSET_PUR_REQUISITION_REPORT";
export const SET_PUR_PR_APPROVAL_REPORT = "SET_PUR_PR_APPROVAL_REPORT";
export const UNSET_PUR_PR_APPROVAL_REPORT = "UNSET_PUR_PR_APPROVAL_REPORT";
export const SET_PUR_REQ_MERGE_REPORT = "SET_PUR_REQ_MERGE_REPORT";
export const UNSET_PUR_REQ_MERGE_REPORT = "UNSET_PUR_REQ_MERGE_REPORT";
export const SET_PUR_RFQ_GEN_REPORT = "SET_PUR_RFQ_GEN_REPORT";
export const UNSET_PUR_RFQ_GEN_REPORT = "UNSET_PUR_RFQ_GEN_REPORT";
export const SET_PUR_CS_STATE_REPORT = "SET_PUR_CS_STATE_REPORT";
export const UNSET_PUR_CS_STATE_REPORT = "UNSET_PUR_CS_STATE_REPORT";
export const SET_PUR_CS_APPROVAL_REPORT = "SET_PUR_CS_APPROVAL_REPORT";
export const UNSET_PUR_CS_APPROVAL_REPORT = "UNSET_PUR_CS_APPROVAL_REPORT";
export const SET_PUR_PO_ORDER_REPORT = "SET_PUR_PO_ORDER_REPORT";
export const UNSET_PUR_PO_ORDER_REPORT = "UNSET_PUR_PO_ORDER_REPORT";
export const SET_PUR_PO_APPROVAL_REPORT = "SET_PUR_PO_APPROVAL_REPORT";
export const UNSET_PUR_PO_APPROVAL_REPORT = "UNSET_PUR_PO_APPROVAL_REPORT";
export const SET_PUR_RECEIVE_REPORT = "SET_PUR_RECEIVE_REPORT";
export const UNSET_PUR_RECEIVE_REPORT = "UNSET_PUR_RECEIVE_REPORT";

//===================== Attendance Module ==============================

// Shift 
export const SET_SHIFT_LIST = "SET_SHIFT_LIST";
export const UNSET_SHIFT_LIST = "UNSET_SHIFT_LIST";

// weekend 
export const SET_WEEKEND_LIST = "SET_WEEKEND_LIST";
export const UNSET_WEEKEND_LIST = "UNSET_WEEKEND_LIST";
// Employee wise weekend
export const SET_EMPLOYEE_WEEKEND_LIST = "SET_EMPLOYEE_WEEKEND_LIST";
export const UNSET_EMPLOYEE_WEEKEND_LIST = "UNSET_EMPLOYEE_WEEKEND_LIST";

// Holiday
export const SET_HOLIDAY_LIST = "SET_HOLIDAY_LIST";
export const UNSET_HOLIDAY_LIST = "UNSET_HOLIDAY_LIST";

// days 
export const SET_DAYS_LIST = "SET_DAYS_LIST";
export const UNSET_DAYS_LIST = "UNSET_DAYS_LIST";

// Employee Shift Mapping
export const SET_EMPLOYEE_SHIFT_MAPPING_LIST = "SET_EMPLOYEE_SHIFT_MAPPING_LIST";
export const UNSET_EMPLOYEE_SHIFT_MAPPING_LIST = "UNSET_EMPLOYEE_SHIFT_MAPPING_LIST";
export const SET_EMPLOYEE_SHIFT_MAPPING_DETAILS = "SET_EMPLOYEE_SHIFT_MAPPING_DETAILS";
export const UNSET_EMPLOYEE_SHIFT_MAPPING_DETAILS = "UNSET_EMPLOYEE_SHIFT_MAPPING_DETAILS";

// Attendance Reconciliation
export const SET_ATTENDANCE_RECONCILIATION_LIST = "SET_ATTENDANCE_RECONCILIATION_LIST";
export const UNSET_ATTENDANCE_RECONCILIATION_LIST = "UNSET_ATTENDANCE_RECONCILIATION_LIST";
export const SET_EDITING_ATTENDANCE_RECONCILIATION = "SET_EDITING_ATTENDANCE_RECONCILIATION";
export const UNSET_EDITING_ATTENDANCE_RECONCILIATION = "UNSET_EDITING_ATTENDANCE_RECONCILIATION";

// Manual Attendance
export const SET_MANUAL_ATTENDANCE = "SET_MANUAL_ATTENDANCE";
export const UNSET_MANUAL_ATTENDANCE = "UNSET_MANUAL_ATTENDANCE";

// Attendance Reports
export const SET_ATTENDANCE_SUMMARY_REPORT = "SET_ATTENDANCE_SUMMARY_REPORT";
export const UNSET_ATTENDANCE_SUMMARY_REPORT = "UNSET_ATTENDANCE_SUMMARY_REPORT";
export const SET_MY_DAILY_ATTENDANCE_REPORT = "SET_MY_DAILY_ATTENDANCE_REPORT";
export const UNSET_MY_DAILY_ATTENDANCE_REPORT = "UNSET_MY_DAILY_ATTENDANCE_REPORT";
export const SET_EMPLOYEE_DAILY_ATTENDANCE_SHEET_REPORT = "SET_EMPLOYEE_DAILY_ATTENDANCE_SHEET_REPORT";
export const UNSET_EMPLOYEE_DAILY_ATTENDANCE_SHEET_REPORT = "UNSET_EMPLOYEE_DAILY_ATTENDANCE_SHEET_REPORT";
export const SET_OVERTIME_REPORT = "SET_OVERTIME_REPORT";
export const UNSET_OVERTIME_REPORT = "UNSET_OVERTIME_REPORT";
export const SET_LATE_EARLY_REPORT = "SET_LATE_EARLY_REPORT";
export const UNSET_LATE_EARLY_REPORT = "UNSET_LATE_EARLY_REPORT";
export const SET_ABSENT_REPORT = "SET_ABSENT_REPORT";
export const UNSET_ABSENT_REPORT = "UNSET_ABSENT_REPORT";
export const SET_ATTENDANCE_REGISTER_REPORT = "SET_ATTENDANCE_REGISTER_REPORT";
export const UNSET_ATTENDANCE_REGISTER_REPORT = "UNSET_ATTENDANCE_REGISTER_REPORT";
export const SET_SHIFT_WISE_ATTENDANCE_SUMMARY_REPORT = "SET_SHIFT_WISE_ATTENDANCE_SUMMARY_REPORT";
export const UNSET_SHIFT_WISE_ATTENDANCE_SUMMARY_REPORT = "UNSET_SHIFT_WISE_ATTENDANCE_SUMMARY_REPORT";
export const SET_ATTENDANCE_RECONCILIATION_REPORT = "SET_ATTENDANCE_RECONCILIATION_REPORT";
export const UNSET_ATTENDANCE_RECONCILIATION_REPORT = "UNSET_ATTENDANCE_RECONCILIATION_REPORT";
export const SET_WORKFORCE_AVAILABILITY_REPORT = "SET_WORKFORCE_AVAILABILITY_REPORT";
export const UNSET_WORKFORCE_AVAILABILITY_REPORT = "UNSET_WORKFORCE_AVAILABILITY_REPORT";
export const SET_ATTENDANCE_LEDGER_REPORT = "SET_ATTENDANCE_LEDGER_REPORT";
export const UNSET_ATTENDANCE_LEDGER_REPORT = "UNSET_ATTENDANCE_LEDGER_REPORT";
export const SET_DEPARTMENT_PERFORMANCE_REPORT = "SET_DEPARTMENT_PERFORMANCE_REPORT";
export const UNSET_DEPARTMENT_PERFORMANCE_REPORT = "UNSET_DEPARTMENT_PERFORMANCE_REPORT";

//Roster
export const SET_ROSTER_LIST = "SET_ROSTER_LIST";
export const UNSET_ROSTER_LIST = "UNSET_ROSTER_LIST";

//===================== Sales Module ==============================

//sales letter setup
export const SET_SALES_LETTER_INFO_LIST = "SET_SALES_LETTER_INFO_LIST";
export const UNSET_SALES_LETTER_INFO_LIST = "UNSET_SALES_LETTER_INFO_LIST";

//sales fixed percentage commission
export const SET_SALES_FIXED_PERCENTAGE_COMMISSION_LIST = "SET_SALES_FIXED_PERCENTAGE_COMMISSION_LIST";
export const UNSET_SALES_FIXED_PERCENTAGE_COMMISSION_LIST = "UNSET_SALES_FIXED_PERCENTAGE_COMMISSION_LIST";
export const SET_EDITING_SALES_FIXED_PERCENTAGE_COMMISSION = "SET_EDITING_SALES_FIXED_PERCENTAGE_COMMISSION";
export const UNSET_EDITING_SALES_FIXED_PERCENTAGE_COMMISSION = "UNSET_EDITING_SALES_FIXED_PERCENTAGE_COMMISSION";

//sales tiered commission 
export const SET_SALES_TIERED_COMMISSION_LIST = "SET_SALES_TIERED_COMMISSION_LIST";
export const UNSET_SALES_TIERED_COMMISSION_LIST = "UNSET_SALES_TIERED_COMMISSION_LIST";
export const SET_EDITING_SALES_TIERED_COMMISSION = "SET_EDITING_SALES_TIERED_COMMISSION";
export const UNSET_EDITING_SALES_TIERED_COMMISSION = "UNSET_EDITING_SALES_TIERED_COMMISSION";

//sales product based commission 
export const SET_SALES_PRODUCT_BASED_COMMISSION_LIST = "SET_SALES_PRODUCT_BASED_COMMISSION_LIST";
export const UNSET_SALES_PRODUCT_BASED_COMMISSION_LIST = "UNSET_SALES_PRODUCT_BASED_COMMISSION_LIST";
export const SET_EDITING_SALES_PRODUCT_BASED_COMMISSION = "SET_EDITING_SALES_PRODUCT_BASED_COMMISSION";
export const UNSET_EDITING_SALES_PRODUCT_BASED_COMMISSION = "UNSET_EDITING_SALES_PRODUCT_BASED_COMMISSION";

//sales profit based commission 
export const SET_SALES_PROFIT_BASED_COMMISSION_LIST = "SET_SALES_PROFIT_BASED_COMMISSION_LIST";
export const UNSET_SALES_PROFIT_BASED_COMMISSION_LIST = "UNSET_SALES_PROFIT_BASED_COMMISSION_LIST";
export const SET_EDITING_SALES_PROFIT_BASED_COMMISSION = "SET_EDITING_SALES_PROFIT_BASED_COMMISSION";
export const UNSET_EDITING_SALES_PROFIT_BASED_COMMISSION = "UNSET_EDITING_SALES_PROFIT_BASED_COMMISSION";

//sales leads
export const SET_SALES_LEADS_LIST = "SET_SALES_LEADS_LIST";
export const UNSET_SALES_LEADS_LIST = "UNSET_SALES_LEADS_LIST";
//sales orders
export const SET_SALE_ORDER_LIST = "SET_SALE_ORDER_LIST";
export const UNSET_SALE_ORDER_LIST = "UNSET_SALE_ORDER_LIST";
//sales Invoice
export const SET_SALE_INVOICE_LIST = "SET_SALE_INVOICE_LIST";
export const UNSET_SALE_INVOICE_LIST = "UNSET_SALE_INVOICE_LIST";
// Sale payment
export const SET_SALE_PAYMENT_LIST = "SET_SALE_PAYMENT_LIST";
export const UNSET_SALE_PAYMENT_LIST = "UNSET_SALE_PAYMENT_LIST";
// reports
export const SET_SALE_STATEMENT_REPORTS = "SET_SALE_STATEMENT_REPORTS";
export const UNSET_SALE_STATEMENT_REPORTS = "UNSET_SALE_STATEMENT_REPORTS";
//sales lead source types
export const SET_LEAD_SOURCE_TYPES_LIST = "SET_LEAD_SOURCE_TYPES_LIST";
export const UNSET_LEAD_SOURCE_TYPES_LIST = "UNSET_LEAD_SOURCE_TYPES_LIST";

//sales action
export const SET_SALES_ACTION_LIST = "SET_SALES_ACTION_LIST";
export const UNSET_SALES_ACTION_LIST = "UNSET_SALES_ACTION_LIST";

//sales lead interest routes
export const SET_LEAD_INTEREST_ROUTES_LIST = "SET_LEAD_INTEREST_ROUTES_LIST";
export const UNSET_LEAD_INTEREST_ROUTES_LIST = "UNSET_LEAD_INTEREST_ROUTES_LIST";

//sales lead status routes
export const SET_LEAD_STATUS_ROUTES_LIST = "SET_LEAD_STATUS_ROUTES_LIST";
export const UNSET_LEAD_STATUS_ROUTES_LIST = "UNSET_LEAD_STATUS_ROUTES_LIST";

//sales lead details routes
export const SET_LEAD_DETAILS_ROUTES_LIST = "SET_LEAD_DETAILS_ROUTES_LIST";
export const UNSET_LEAD_DETAILS_ROUTES_LIST = "UNSET_LEAD_DETAILS_ROUTES_LIST";

//sales proposals routes
export const SET_PROPOSALS_ROUTES_LIST = "SET_PROPOSALS_ROUTES_LIST";
export const UNSET_PROPOSALS_ROUTES_LIST = "UNSET_PROPOSALS_ROUTES_LIST";

//sales proposal assigned routes
export const SET_PROPOSAL_LEAD_ASSIGNED_LIST = "SET_PROPOSAL_LEAD_ASSIGNED_LIST";
export const UNSET_PROPOSAL_LEAD_ASSIGNED_LIST = "UNSET_PROPOSAL_LEAD_ASSIGNED_LIST";

//sales proposal status routes
export const SET_PROPOSAL_STATUS_ROUTES_LIST = "SET_PROPOSAL_STATUS_ROUTES_LIST";
export const UNSET_PROPOSAL_STATUS_ROUTES_LIST = "UNSET_PROPOSAL_STATUS_ROUTES_LIST";

//sales work order routes
export const SET_WORK_ORDER_ROUTES_LIST = "SET_WORK_ORDER_ROUTES_LIST";
export const UNSET_WORK_ORDER_ROUTES_LIST = "UNSET_WORK_ORDER_ROUTES_LIST";

//sales work order activity log routes
export const SET_WORK_ORDER_ACTIVITY_LOG_LIST = "SET_WORK_ORDER_ACTIVITY_LOG_LIST";
export const UNSET_WORK_ORDER_ACTIVITY_LOG_LIST = "UNSET_WORK_ORDER_ACTIVITY_LOG_LIST";

//sales work order status routes
export const SET_WORK_ORDER_STATUS_LIST = "SET_WORK_ORDER_STATUS_LIST";
export const UNSET_WORK_ORDER_STATUS_LIST = "UNSET_WORK_ORDER_STATUS_LIST";

//sales team
export const SET_SALES_TEAM_LIST = "SET_SALES_TEAM_LIST";
export const UNSET_SALES_TEAM_LIST = "UNSET_SALES_TEAM_LIST";

//sales department target
export const SET_SALES_DEPARTMENT_TARGET_LIST = "SET_SALES_DEPARTMENT_TARGET_LIST";
export const UNSET_SALES_DEPARTMENT_TARGET_LIST = "UNSET_SALES_DEPARTMENT_TARGET_LIST";

//Sales Team Target
export const SET_SALES_TEAM_TARGET_LIST = "SET_SALES_TEAM_TARGET_LIST";
export const UNSET_SALES_TEAM_TARGET_LIST = "UNSET_SALES_TEAM_TARGET_LIST";

//Sales Employee Target
export const SET_SALES_EMPLOYEE_TARGET_LIST = "SET_SALES_EMPLOYEE_TARGET_LIST";
export const UNSET_SALES_EMPLOYEE_TARGET_LIST = "UNSET_SALES_EMPLOYEE_TARGET_LIST";


//===================== Accounts Module ==============================
// Accounts Head
// Accounts Reports
export const SET_BALANCE_SHEET_REPORT = "SET_BALANCE_SHEET_REPORT";
export const UNSET_BALANCE_SHEET_REPORT = "UNSET_BALANCE_SHEET_REPORT";
export const SET_TRIAL_BALANCE_REPORT = "SET_TRIAL_BALANCE_REPORT";
export const UNSET_TRIAL_BALANCE_REPORT = "UNSET_TRIAL_BALANCE_REPORT";
export const SET_INCOME_STATEMENT_REPORT = "SET_INCOME_STATEMENT_REPORT";
export const UNSET_INCOME_STATEMENT_REPORT = "UNSET_INCOME_STATEMENT_REPORT";
export const SET_CASH_FLOW_REPORT = "SET_CASH_FLOW_REPORT";
export const UNSET_CASH_FLOW_REPORT = "UNSET_CASH_FLOW_REPORT";
export const SET_CHANGES_IN_EQUITY_REPORT = "SET_CHANGES_IN_EQUITY_REPORT";
export const UNSET_CHANGES_IN_EQUITY_REPORT = "UNSET_CHANGES_IN_EQUITY_REPORT";
export const SET_RECEIPT_AND_PAYMENT_REPORT = "SET_RECEIPT_AND_PAYMENT_REPORT";
export const UNSET_RECEIPT_AND_PAYMENT_REPORT = "UNSET_RECEIPT_AND_PAYMENT_REPORT";
export const SET_DAY_BOOK_REPORT = "SET_DAY_BOOK_REPORT";
export const UNSET_DAY_BOOK_REPORT = "UNSET_DAY_BOOK_REPORT";
export const SET_CASH_BOOK_REPORT = "SET_CASH_BOOK_REPORT";
export const UNSET_CASH_BOOK_REPORT = "UNSET_CASH_BOOK_REPORT";
export const SET_BANK_BOOK_REPORT = "SET_BANK_BOOK_REPORT";
export const UNSET_BANK_BOOK_REPORT = "UNSET_BANK_BOOK_REPORT";
export const SET_LEDGER_REPORT = "SET_LEDGER_REPORT";
export const UNSET_LEDGER_REPORT = "UNSET_LEDGER_REPORT";

// Accounts Dropdowns
export const SET_ACCOUNT_HEADS_LIST = "SET_ACCOUNT_HEADS_LIST";
export const UNSET_ACCOUNT_HEADS_LIST = "UNSET_ACCOUNT_HEADS_LIST";
export const SET_PAYMENT_ACCOUNT_HEADS_LIST = "SET_PAYMENT_ACCOUNT_HEADS_LIST";
export const UNSET_PAYMENT_ACCOUNT_HEADS_LIST = "UNSET_PAYMENT_ACCOUNT_HEADS_LIST";
export const SET_ACCOUNT_HEAD_LIST = "SET_ACCOUNT_HEAD_LIST";
export const UNSET_ACCOUNT_HEAD_LIST = "UNSET_ACCOUNT_HEAD_LIST";

// Non-Cash-Account-Heads
export const SET_NON_CASH_ACCOUNT_HEAD_LIST = "SET_NON_CASH_ACCOUNT_HEAD_LIST";
export const UNSET_NON_CASH_ACCOUNT_HEAD_LIST = "UNSET_NON_CASH_ACCOUNT_HEAD_LIST";

// Cash Account-Heads
export const SET_CASH_ACCOUNT_HEAD_LIST = "SET_CASH_ACCOUNT_HEAD_LIST";
export const UNSET_CASH_ACCOUNT_HEAD_LIST = "UNSET_CASH_ACCOUNT_HEAD_LIST";

//Payment Account Heads
export const SET_PAYMENT_ACCOUNT_HEAD_LIST = "SET_PAYMENT_ACCOUNT_HEAD_LIST";
export const UNSET_PAYMENT_ACCOUNT_HEAD_LIST = "UNSET_PAYMENT_ACCOUNT_HEAD_LIST";

export const SET_COST_CENTERS_LIST = "SET_COST_CENTERS_LIST";
export const UNSET_COST_CENTERS_LIST = "UNSET_COST_CENTERS_LIST";


export const SET_VOUCHER_LIST = "SET_VOUCHER_LIST";
export const UNSET_VOUCHER_LIST = "UNSET_VOUCHER_LIST";

//Money Requisition
export const SET_MONEY_REQUISITION_LIST = "SET_MONEY_REQUISITION_LIST";
export const UNSET_MONEY_REQUISITION_LIST = "UNSET_MONEY_REQUISITION_LIST";
export const SET_EDITING_MONEY_REQUISITION_LIST = "SET_EDITING_MONEY_REQUISITION_LIST";
export const UNSET_EDITING_MONEY_REQUISITION_LIST = "UNSET_EDITING_MONEY_REQUISITION_LIST";

//Party (Payee/Depositor)
export const SET_PARTY_LIST = "SET_PARTY_LIST";
export const UNSET_PARTY_LIST = "UNSET_PARTY_LIST";

//Cheque Book
export const SET_CHEQUE_BOOK_LIST = "SET_CHEQUE_BOOK_LIST";
export const UNSET_CHEQUE_BOOK_LIST = "UNSET_CHEQUE_BOOK_LIST";
export const SET_CHEQUE_LIST = "SET_CHEQUE_LIST";
export const UNSET_CHEQUE_LIST = "UNSET_CHEQUE_LIST";
export const SET_EDITING_CHEQUE_BOOK_LIST = "SET_EDITING_CHEQUE_BOOK_LIST";
export const UNSET_EDITING_CHEQUE_BOOK_LIST = "UNSET_EDITING_CHEQUE_BOOK_LIST";

//Bank
export const SET_BANK_LIST = "SET_BANK_LIST";
export const UNSET_BANK_LIST = "UNSET_BANK_LIST";
export const SET_EDITING_BANK_LIST = "SET_EDITING_BANK_LIST";
export const UNSET_EDITING_BANK_LIST = "UNSET_EDITING_BANK_LIST";

//Branch
export const SET_BANK_BRANCH_LIST = "SET_BANK_BRANCH_LIST";
export const UNSET_BANK_BRANCH_LIST = "UNSET_BANK_BRANCH_LIST";
export const SET_EDITING_BANK_BRANCH_LIST = "SET_EDITING_BANK_BRANCH_LIST";
export const UNSET_EDITING_BANK_BRANCH_LIST = "UNSET_EDITING_BANK_BRANCH_LIST";

//Bank Account
export const SET_BANK_ACCOUNT_LIST = "SET_BANK_ACCOUNT_LIST";
export const UNSET_BANK_ACCOUNT_LIST = "UNSET_BANK_ACCOUNT_LIST";
export const SET_EDITING_BANK_ACCOUNT_LIST = "SET_EDITING_BANK_ACCOUNT_LIST";
export const UNSET_EDITING_BANK_ACCOUNT_LIST = "UNSET_EDITING_BANK_ACCOUNT_LIST";

//Vat Book
export const SET_VAT_REGISTER_LIST = "SET_VAT_REGISTER_LIST";
export const UNSET_VAT_REGISTER_LIST = "UNSET_VAT_REGISTER_LIST";
export const SET_VAT_PAYMENT_RECORD = "SET_VAT_PAYMENT_RECORD";
export const UNSET_VAT_PAYMENT_RECORD = "UNSET_VAT_PAYMENT_RECORD";
export const SET_VAT_PAYMENT_DETAILS = "SET_VAT_PAYMENT_DETAILS";
export const UNSET_VAT_PAYMENT_DETAILS = "UNSET_VAT_PAYMENT_DETAILS";

//Tax Book
export const SET_TAX_REGISTER_LIST = "SET_TAX_REGISTER_LIST";
export const UNSET_TAX_REGISTER_LIST = "UNSET_TAX_REGISTER_LIST";
export const SET_TAX_PAYMENT_RECORD = "SET_TAX_PAYMENT_RECORD";
export const UNSET_TAX_PAYMENT_RECORD = "UNSET_TAX_PAYMENT_RECORD";
export const SET_TAX_PAYMENT_DETAILS = "SET_TAX_PAYMENT_DETAILS";
export const UNSET_TAX_PAYMENT_DETAILS = "UNSET_TAX_PAYMENT_DETAILS";

//Bank Reconciliation
export const SET_BANK_RECONCILATION_RECORD_LIST = "SET_BANK_RECONCILATION_RECORD_LIST";
export const UNSET_BANK_RECONCILATION_RECORD_LIST = "UNSET_BANK_RECONCILATION_RECORD_LIST";

export const SET_BANK_RECONCILATION_STATEMENT = "SET_BANK_RECONCILATION_STATEMENT";
export const UNSET_BANK_RECONCILATION_STATEMENT = "UNSET_BANK_RECONCILATION_STATEMENT";

//===================== Production Module ==============================

//Master Setup
export const SET_PRODUCTION_STYLE_LIST = "SET_PRODUCTION_STYLE_LIST";
export const UNSET_PRODUCTION_STYLE_LIST = "UNSET_PRODUCTION_STYLE_LIST";
export const SET_PRODUCTION_POS_LIST = "SET_PRODUCTION_POS_LIST";
export const UNSET_PRODUCTION_POS_LIST = "UNSET_PRODUCTION_POS_LIST";
export const SET_PRODUCTION_COLOR_LIST = "SET_PRODUCTION_COLOR_LIST";
export const UNSET_PRODUCTION_COLOR_LIST = "UNSET_PRODUCTION_COLOR_LIST";
export const SET_PRODUCTION_SIZE_LIST = "SET_PRODUCTION_SIZE_LIST";
export const UNSET_PRODUCTION_SIZE_LIST = "UNSET_PRODUCTION_SIZE_LIST";
export const SET_PRODUCTION_DYEING_LIST = "SET_PRODUCTION_DYEING_LIST";
export const UNSET_PRODUCTION_DYEING_LIST = "UNSET_PRODUCTION_DYEING_LIST";
export const SET_PRODUCTION_BOM_LIST = "SET_PRODUCTION_BOM_LIST";
export const UNSET_PRODUCTION_BOM_LIST = "UNSET_PRODUCTION_BOM_LIST";
export const SET_PRODUCTION_CUTTING_LIST = "SET_PRODUCTION_CUTTING_LIST";
export const UNSET_PRODUCTION_CUTTING_LIST = "UNSET_PRODUCTION_CUTTING_LIST";
export const SET_PRODUCTION_BUNDLE_LIST = "SET_PRODUCTION_BUNDLE_LIST";
export const UNSET_PRODUCTION_BUNDLE_LIST = "UNSET_PRODUCTION_BUNDLE_LIST";
export const SET_PRODUCTION_SEWING_LINE_LIST = "SET_PRODUCTION_SEWING_LINE_LIST";
export const UNSET_PRODUCTION_SEWING_LINE_LIST = "UNSET_PRODUCTION_SEWING_LINE_LIST";
export const SET_PRODUCTION_SEWING_INPUT_LIST = "SET_PRODUCTION_SEWING_INPUT_LIST";
export const UNSET_PRODUCTION_SEWING_INPUT_LIST = "UNSET_PRODUCTION_SEWING_INPUT_LIST";
export const SET_PRODUCTION_SEWING_OUTPUT_LIST = "SET_PRODUCTION_SEWING_OUTPUT_LIST";
export const UNSET_PRODUCTION_SEWING_OUTPUT_LIST = "UNSET_PRODUCTION_SEWING_OUTPUT_LIST";
export const SET_PRODUCTION_QC_LIST = "SET_PRODUCTION_QC_LIST";
export const UNSET_PRODUCTION_QC_LIST = "UNSET_PRODUCTION_QC_LIST";
export const SET_PRODUCTION_QC_INLINE_LIST = "SET_PRODUCTION_QC_INLINE_LIST";
export const UNSET_PRODUCTION_QC_INLINE_LIST = "UNSET_PRODUCTION_QC_INLINE_LIST";
export const SET_PRODUCTION_QC_FINAL_LIST = "SET_PRODUCTION_QC_FINAL_LIST";
export const UNSET_PRODUCTION_QC_FINAL_LIST = "UNSET_PRODUCTION_QC_FINAL_LIST";
export const SET_PRODUCTION_FINISHING_LIST = "SET_PRODUCTION_FINISHING_LIST";
export const UNSET_PRODUCTION_FINISHING_LIST = "UNSET_PRODUCTION_FINISHING_LIST";
export const SET_PRODUCTION_FINISHING_INPUT_LIST = "SET_PRODUCTION_FINISHING_INPUT_LIST";
export const UNSET_PRODUCTION_FINISHING_INPUT_LIST = "UNSET_PRODUCTION_FINISHING_INPUT_LIST";
export const SET_PRODUCTION_FINISHING_OUTPUT_LIST = "SET_PRODUCTION_FINISHING_OUTPUT_LIST";
export const UNSET_PRODUCTION_FINISHING_OUTPUT_LIST = "UNSET_PRODUCTION_FINISHING_OUTPUT_LIST";
export const SET_BUYER_ORDER_LIST = "SET_BUYER_ORDER_LIST";
export const UNSET_BUYER_ORDER_LIST = "UNSET_BUYER_ORDER_LIST";
export const SET_PRODUCTION_ORDER_LIST = "SET_PRODUCTION_ORDER_LIST";
export const UNSET_PRODUCTION_ORDER_LIST = "UNSET_PRODUCTION_ORDER_LIST";
export const SET_DYEING_ORDER_LIST = "SET_DYEING_ORDER_LIST";
export const UNSET_DYEING_ORDER_LIST = "UNSET_DYEING_ORDER_LIST";
export const SET_PROFORMA_INVOICE_LIST = "SET_PROFORMA_INVOICE_LIST";
export const UNSET_PROFORMA_INVOICE_LIST = "UNSET_PROFORMA_INVOICE_LIST";
export const SET_MASTER_SALES_CONTACT_LIST = "SET_MASTER_SALES_CONTACT_LIST";
export const UNSET_MASTER_SALES_CONTACT_LIST = "UNSET_MASTER_SALES_CONTACT_LIST";
export const SET_SALES_CONTACT_LIST = "SET_SALES_CONTACT_LIST";
export const UNSET_SALES_CONTACT_LIST = "UNSET_SALES_CONTACT_LIST";
export const SET_BHP_PURCHASE_ORDER_LIST = "SET_BHP_PURCHASE_ORDER_LIST";
export const UNSET_BHP_PURCHASE_ORDER_LIST = "UNSET_BHP_PURCHASE_ORDER_LIST";
export const SET_INVOICE_BILL_LIST = "SET_INVOICE_BILL_LIST";
export const UNSET_INVOICE_BILL_LIST = "UNSET_INVOICE_BILL_LIST";





//===================== Asset Module ==============================

//Asset Category
export const SET_ASSET_CATEGORY_LIST = "SET_ASSET_CATEGORY_LIST";
export const UNSET_ASSET_CATEGORY_LIST = "UNSET_ASSET_CATEGORY_LIST";

//Asset Depreciation
export const SET_ASSET_DEPRECIATION_METHOD_LIST = "SET_ASSET_DEPRECIATION_METHOD_LIST";
export const UNSET_ASSET_DEPRECIATION_METHOD_LIST = "UNSET_ASSET_DEPRECIATION_METHOD_LIST";

//Asset status type
export const SET_ASSET_STATUS_TYPES_LIST = "SET_ASSET_STATUS_TYPES_LIST";
export const UNSET_ASSET_STATUS_TYPES_LIST = "UNSET_ASSET_STATUS_TYPES_LIST";

//Asset Location
export const SET_ASSET_LOCATION_LIST = "SET_ASSET_LOCATION_LIST";
export const UNSET_ASSET_LOCATION_LIST = "UNSET_ASSET_LOCATION_LIST";

//Asset Mapping
export const SET_ASSET_MAPPING_LIST = "SET_ASSET_MAPPING_LIST";
export const UNSET_ASSET_MAPPING_LIST = "UNSET_ASSET_MAPPING_LIST";

//Asset Registration
export const SET_ASSET_REGISTRATION_LIST = "SET_ASSET_REGISTRATION_LIST";
export const UNSET_ASSET_REGISTRATION_LIST = "UNSET_ASSET_REGISTRATION_LIST";
export const SET_EDITING_ASSET_REGISTRATION = "SET_EDITING_ASSET_REGISTRATION";
export const UNSET_EDITING_ASSET_REGISTRATION = "UNSET_EDITING_ASSET_REGISTRATION";
export const SET_VIEW_ASSET_REGISTRATION = "SET_VIEW_ASSET_REGISTRATION";
export const UNSET_VIEW_ASSET_REGISTRATION = "UNSET_VIEW_ASSET_REGISTRATION";

//Asset Components
export const SET_ASSET_COMPONENTS_LIST = "SET_ASSET_COMPONENTS_LIST";
export const UNSET_ASSET_COMPONENTS_LIST = "UNSET_ASSET_COMPONENTS_LIST";

//Asset Documents
export const SET_ASSET_DOCUMENTS_LIST = "SET_ASSET_DOCUMENTS_LIST";
export const UNSET_ASSET_DOCUMENTS_LIST = "UNSET_ASSET_DOCUMENTS_LIST";

//Asset Assigned To
export const SET_ASSET_ASSIGNMENTS_LIST = "SET_ASSET_ASSIGNMENTS_LIST";
export const UNSET_ASSET_ASSIGNMENTS_LIST = "UNSET_ASSET_ASSIGNMENTS_LIST";

//Asset Depreciation
export const SET_ASSET_DEPRECIATION_LIST = "SET_ASSET_DEPRECIATION_LIST";
export const UNSET_ASSET_DEPRECIATION_LIST = "UNSET_ASSET_DEPRECIATION_LIST";
export const SET_EDITING_ASSET_DEPRECIATION = "SET_EDITING_ASSET_DEPRECIATION";
export const UNSET_EDITING_ASSET_DEPRECIATION = "UNSET_EDITING_ASSET_DEPRECIATION";
export const SET_VIEWING_ASSET_DEPRECIATION = "SET_VIEWING_ASSET_DEPRECIATION";
export const UNSET_VIEWING_ASSET_DEPRECIATION = "UNSET_VIEWING_ASSET_DEPRECIATION";

//Asset Transfer
export const SET_ASSET_TRANSFER_LIST = "SET_ASSET_TRANSFER_LIST";
export const UNSET_ASSET_TRANSFER_LIST = "UNSET_ASSET_TRANSFER_LIST";
export const SET_ASSET_REGISTER_TRANSFER_LIST = "SET_ASSET_REGISTER_TRANSFER_LIST";
export const UNSET_ASSET_REGISTER_TRANSFER_LIST = "UNSET_ASSET_REGISTER_TRANSFER_LIST";
export const SET_EDITING_ASSET_TRANSFER = "SET_EDITING_ASSET_TRANSFER";
export const UNSET_EDITING_ASSET_TRANSFER = "UNSET_EDITING_ASSET_TRANSFER";

//Asset Maintenance
export const SET_ASSET_MAINTENANCE_LIST = "SET_ASSET_MAINTENANCE_LIST";
export const UNSET_ASSET_MAINTENANCE_LIST = "UNSET_ASSET_MAINTENANCE_LIST";
export const SET_ASSET_REGISTER_MAINTENANCE_LIST = "SET_ASSET_REGISTER_MAINTENANCE_LIST";
export const UNSET_ASSET_REGISTER_MAINTENANCE_LIST = "UNSET_ASSET_REGISTER_MAINTENANCE_LIST";
export const SET_EDITING_ASSET_MAINTENANCE = "SET_EDITING_ASSET_MAINTENANCE";
export const UNSET_EDITING_ASSET_MAINTENANCE = "UNSET_EDITING_ASSET_MAINTENANCE";

//Asset Register Depreciation
export const SET_ASSET_REGISTER_DEPRECIATION_LIST = "SET_ASSET_REGISTER_DEPRECIATION_LIST";
export const UNSET_ASSET_REGISTER_DEPRECIATION_LIST = "UNSET_ASSET_REGISTER_DEPRECIATION_LIST";

//Asset Disposal
export const SET_ASSET_DISPOSAL_LIST = "SET_ASSET_DISPOSAL_LIST";
export const UNSET_ASSET_DISPOSAL_LIST = "UNSET_ASSET_DISPOSAL_LIST";
export const SET_ASSET_REGISTER_DISPOSAL_LIST = "SET_ASSET_REGISTER_DISPOSAL_LIST";
export const UNSET_ASSET_REGISTER_DISPOSAL_LIST = "UNSET_ASSET_REGISTER_DISPOSAL_LIST";
export const SET_EDITING_ASSET_DISPOSAL = "SET_EDITING_ASSET_DISPOSAL";
export const UNSET_EDITING_ASSET_DISPOSAL = "UNSET_EDITING_ASSET_DISPOSAL";


//Asset Preparation
export const SET_ASSET_PREPARATION_LIST = "SET_ASSET_PREPARATION_LIST";
export const UNSET_ASSET_PREPARATION_LIST = "UNSET_ASSET_PREPARATION_LIST";
export const SET_ASSET_REGISTER_PREPARATION_LIST = "SET_ASSET_REGISTER_PREPARATION_LIST";
export const UNSET_ASSET_REGISTER_PREPARATION_LIST = "UNSET_ASSET_REGISTER_PREPARATION_LIST";
export const SET_EDITING_ASSET_PREPARATION = "SET_EDITING_ASSET_PREPARATION";
export const UNSET_EDITING_ASSET_PREPARATION = "UNSET_EDITING_ASSET_PREPARATION";

//Asset Acquisition (Purchase Received)
export const SET_ASSET_ACQUISITION_LIST = "SET_ASSET_ACQUISITION_LIST";
export const UNSET_ASSET_ACQUISITION_LIST = "UNSET_ASSET_ACQUISITION_LIST";
export const SET_EDITING_ASSET_ACQUISITION = "SET_EDITING_ASSET_ACQUISITION";
export const UNSET_EDITING_ASSET_ACQUISITION = "UNSET_EDITING_ASSET_ACQUISITION";
export const SET_VIEW_ASSET_ACQUISITION = "SET_VIEW_ASSET_ACQUISITION";
export const UNSET_VIEW_ASSET_ACQUISITION = "UNSET_VIEW_ASSET_ACQUISITION";

//===================== Leave Management Module==============================

//Settings
export const SET_LEAVE_TYPE_LIST = "SET_LEAVE_TYPE_LIST";
export const UNSET_LEAVE_TYPE_LIST = "UNSET_LEAVE_TYPE_LIST";

//Leave Applocation
export const SET_MY_LEAVE_LIST = "SET_MY_LEAVE_LIST";
export const UNSET_MY_LEAVE_LIST = "UNSET_MY_LEAVE_LIST";
export const SET_LEAVE_DAY_COUNT = "SET_LEAVE_DAY_COUNT";
export const UNSET_LEAVE_DAY_COUNT = "UNSET_LEAVE_DAY_COUNT";

export const SET_LEAVE_TYPE_DETAILS = "SET_LEAVE_TYPE_DETAILS";
export const UNSET_LEAVE_TYPE_DETAILS = "UNSET_LEAVE_TYPE_DETAILS";

//Officials
export const SET_LEAVE_LIST = "SET_LEAVE_LIST";
export const UNSET_LEAVE_LIST = "UNSET_LEAVE_LIST";


//Leave Process
export const SET_LEAVE_BALANCE_LIST = "SET_LEAVE_BALANCE_LIST";
export const UNSET_LEAVE_BALANCE_LIST = "UNSET_LEAVE_BALANCE_LIST";

//Employee Leave Balance
export const SET_EMPLOYEE_LEAVE_BALANCE_LIST = "SET_EMPLOYEE_LEAVE_BALANCE_LIST";
export const UNSET_EMPLOYEE_LEAVE_BALANCE_LIST = "UNSET_EMPLOYEE_LEAVE_BALANCE_LIST";

//Leave Summary Reports
export const SET_LEAVE_SUMMARY_REPORT_LIST = "SET_LEAVE_SUMMARY_REPORT_LIST";
export const UNSET_LEAVE_SUMMARY_REPORT_LIST = "UNSET_LEAVE_SUMMARY_REPORT_LIST";

//Leave Details Report
export const SET_LEAVE_DETAILS_REPORT_LIST = "SET_LEAVE_DETAILS_REPORT_LIST";
export const UNSET_LEAVE_DETAILS_REPORT_LIST = "UNSET_LEAVE_DETAILS_REPORT_LIST";

//Leave Employee Wise Summary Report
export const SET_LEAVE_EMPLOYEE_WISE_SUMMARY_REPORT_LIST = "SET_LEAVE_EMPLOYEE_WISE_SUMMARY_REPORT_LIST";
export const UNSET_LEAVE_EMPLOYEE_WISE_SUMMARY_REPORT_LIST = "UNSET_LEAVE_EMPLOYEE_WISE_SUMMARY_REPORT_LIST";

//Leave Earned Register Report
export const SET_LEAVE_EARNED_REGISTER_REPORT_LIST = "SET_LEAVE_EARNED_REGISTER_REPORT_LIST";
export const UNSET_LEAVE_EARNED_REGISTER_REPORT_LIST = "UNSET_LEAVE_EARNED_REGISTER_REPORT_LIST";

//=====================Payroll Management==============================

//Payroll Settings
export const SET_SALARY_COMPPONENT_LIST = "SET_SALARY_COMPPONENT_LIST";
export const UNSET_SALARY_COMPPONENT_LIST = "UNSET_SALARY_COMPPONENT_LIST";
export const SET_SALARY_COMPPONENT_DETAILS = "SET_SALARY_COMPPONENT_DETAILS";
export const UNSET_SALARY_COMPPONENT_DETAILS = "UNSET_SALARY_COMPPONENT_DETAILS";

//Salary Process
export const SET_SALARY_PROCESS_LIST = "SET_SALARY_PROCESS_LIST";
export const UNSET_SALARY_PROCESS_LIST = "UNSET_SALARY_PROCESS_LIST";
export const SET_SALARY_PROCESS_DETAILS = "SET_SALARY_PROCESS_DETAILS";
export const UNSET_SALARY_PROCESS_DETAILS = "UNSET_SALARY_PROCESS_DETAILS";

//Employee Salary
export const SET_EMPLOYEE_SALARY_LIST = "SET_EMPLOYEE_SALARY_LIST";
export const UNSET_EMPLOYEE_SALARY_LIST = "UNSET_EMPLOYEE_SALARY_LIST";
export const SET_EMPLOYEE_SALARY_DETAILS = "SET_EMPLOYEE_SALARY_DETAILS";
export const UNSET_EMPLOYEE_SALARY_DETAILS = "UNSET_EMPLOYEE_SALARY_DETAILS";

//Salary Ready Attendance
export const SET_SALARY_READY_ATTENDANCE_LIST = "SET_SALARY_READY_ATTENDANCE_LIST";
export const UNSET_SALARY_READY_ATTENDANCE_LIST = "UNSET_SALARY_READY_ATTENDANCE_LIST";
export const SET_SALARY_READY_ATTENDANCE_DETAILS = "SET_SALARY_READY_ATTENDANCE_DETAILS";
export const UNSET_SALARY_READY_ATTENDANCE_DETAILS = "UNSET_SALARY_READY_ATTENDANCE_DETAILS";

//Salary Payments
export const SET_SALARY_PAYMENT_LIST = "SET_SALARY_PAYMENT_LIST";
export const UNSET_SALARY_PAYMENT_LIST = "UNSET_SALARY_PAYMENT_LIST";
export const SET_EDITING_SALARY_PAYMENT = "SET_EDITING_SALARY_PAYMENT";
export const UNSET_EDITING_SALARY_PAYMENT = "UNSET_EDITING_SALARY_PAYMENT";

//Bonus Process
export const SET_BONUS_TYPE_LIST = "SET_BONUS_TYPE_LIST";
export const UNSET_BONUS_TYPE_LIST = "UNSET_BONUS_TYPE_LIST";
export const SET_BONUS_TYPE_DETAILS = "SET_BONUS_TYPE_DETAILS";
export const UNSET_BONUS_TYPE_DETAILS = "UNSET_BONUS_TYPE_DETAILS";
export const SET_BONUS_PROCESS_LIST = "SET_BONUS_PROCESS_LIST";
export const UNSET_BONUS_PROCESS_LIST = "UNSET_BONUS_PROCESS_LIST";
export const SET_EMPLOYEE_BONUS_LIST = "SET_EMPLOYEE_BONUS_LIST";
export const UNSET_EMPLOYEE_BONUS_LIST = "UNSET_EMPLOYEE_BONUS_LIST";
export const SET_EMPLOYEE_BONUS_DETAILS = "SET_EMPLOYEE_BONUS_DETAILS";
export const UNSET_EMPLOYEE_BONUS_DETAILS = "UNSET_EMPLOYEE_BONUS_DETAILS";
export const SET_BONUS_PROCESS_DETAILS_LIST = "SET_BONUS_PROCESS_DETAILS_LIST";
export const UNSET_BONUS_PROCESS_DETAILS_LIST = "UNSET_BONUS_PROCESS_DETAILS_LIST";

//Bonus Payment
export const SET_BONUS_PAYMENT_LIST = "SET_BONUS_PAYMENT_LIST";
export const UNSET_BONUS_PAYMENT_LIST = "UNSET_BONUS_PAYMENT_LIST";
export const SET_BONUS_PAYMENT_INVOICE_DETAILS = "SET_BONUS_PAYMENT_INVOICE_DETAILS";
export const UNSET_BONUS_PAYMENT_INVOICE_DETAILS = "UNSET_BONUS_PAYMENT_INVOICE_DETAILS";

//Monthly Salary Report
export const SET_MONTHLY_SALARY_REPORT_LIST = "SET_MONTHLY_SALARY_REPORT_LIST";
export const UNSET_MONTHLY_SALARY_REPORT_LIST = "UNSET_MONTHLY_SALARY_REPORT_LIST";

//Salary Summary Report
export const SET_SALARY_SUMMARY_REPORT_LIST = "SET_SALARY_SUMMARY_REPORT_LIST";
export const UNSET_SALARY_SUMMARY_REPORT_LIST = "UNSET_SALARY_SUMMARY_REPORT_LIST";

//Salary Pay Register Report
export const SET_SALARY_PAY_REGISTER_REPORT_LIST = "SET_SALARY_PAY_REGISTER_REPORT_LIST";
export const UNSET_SALARY_PAY_REGISTER_REPORT_LIST = "UNSET_SALARY_PAY_REGISTER_REPORT_LIST";

//Salary Bank Advice Report
export const SET_SALARY_BANK_ADVICE_REPORT_LIST = "SET_SALARY_BANK_ADVICE_REPORT_LIST";
export const UNSET_SALARY_BANK_ADVICE_REPORT_LIST = "UNSET_SALARY_BANK_ADVICE_REPORT_LIST";

//Salary Outstanding Report
export const SET_SALARY_OUTSTANDING_REPORT_LIST = "SET_SALARY_OUTSTANDING_REPORT_LIST";
export const UNSET_SALARY_OUTSTANDING_REPORT_LIST = "UNSET_SALARY_OUTSTANDING_REPORT_LIST";

//Employee Salary Employee History Report
export const SET_EMPLOYEE_SALARY_HISTORY_REPORT_LIST = "SET_EMPLOYEE_SALARY_HISTORY_REPORT_LIST";   
export const UNSET_EMPLOYEE_SALARY_HISTORY_REPORT_LIST = "UNSET_EMPLOYEE_SALARY_HISTORY_REPORT_LIST";

//Salary Aging Report
export const SET_SALARY_AGING_REPORT_LIST = "SET_SALARY_AGING_REPORT_LIST";   
export const UNSET_SALARY_AGING_REPORT_LIST = "UNSET_SALARY_AGING_REPORT_LIST";

//Salary Aging Report
export const SET_ALLOWANCE_DEDUCTION_BREAKUP_REPORT_LIST = "SET_ALLOWANCE_DEDUCTION_BREAKUP_REPORT_LIST";   
export const UNSET_ALLOWANCE_DEDUCTION_BREAKUP_REPORT_LIST = "UNSET_ALLOWANCE_DEDUCTION_BREAKUP_REPORT_LIST";

//Tax Summary Report
export const SET_TAX_SUMMARY_REPORT_LIST = "SET_TAX_SUMMARY_REPORT_LIST";   
export const UNSET_TAX_SUMMARY_REPORT_LIST = "UNSET_TAX_SUMMARY_REPORT_LIST";

//Salary Trend Report
export const SET_SALARY_TREND_REPORT_LIST = "SET_SALARY_TREND_REPORT_LIST";   
export const UNSET_SALARY_TREND_REPORT_LIST = "UNSET_SALARY_TREND_REPORT_LIST";

//OT Incentive Report
export const SET_OT_INCENTIVE_REPORT_LIST = "SET_OT_INCENTIVE_REPORT_LIST";   
export const UNSET_OT_INCENTIVE_REPORT_LIST = "UNSET_OT_INCENTIVE_REPORT_LIST";

//Full Payroll Ledger Report
export const SET_FULL_PAYROLL_LEDGER_REPORT_LIST = "SET_FULL_PAYROLL_LEDGER_REPORT_LIST";   
export const UNSET_FULL_PAYROLL_LEDGER_REPORT_LIST = "UNSET_FULL_PAYROLL_LEDGER_REPORT_LIST";

//Bonus Reports
export const SET_BONUS_PROCESS_REPORT_LIST = "SET_BONUS_PROCESS_REPORT_LIST";
export const UNSET_BONUS_PROCESS_REPORT_LIST = "UNSET_BONUS_PROCESS_REPORT_LIST";
export const SET_BONUS_SUMMARY_REGISTER_REPORT_LIST = "SET_BONUS_SUMMARY_REGISTER_REPORT_LIST";
export const UNSET_BONUS_SUMMARY_REGISTER_REPORT_LIST = "UNSET_BONUS_SUMMARY_REGISTER_REPORT_LIST";
export const SET_BONUS_PAYMENT_REGISTER_REPORT_LIST = "SET_BONUS_PAYMENT_REGISTER_REPORT_LIST";
export const UNSET_BONUS_PAYMENT_REGISTER_REPORT_LIST = "UNSET_BONUS_PAYMENT_REGISTER_REPORT_LIST";
export const SET_BONUS_BANK_ADVICE_REPORT_LIST = "SET_BONUS_BANK_ADVICE_REPORT_LIST";
export const UNSET_BONUS_BANK_ADVICE_REPORT_LIST = "UNSET_BONUS_BANK_ADVICE_REPORT_LIST";
export const SET_EMPLOYEE_BONUS_HISTORY_REPORT_LIST = "SET_EMPLOYEE_BONUS_HISTORY_REPORT_LIST";
export const UNSET_EMPLOYEE_BONUS_HISTORY_REPORT_LIST = "UNSET_EMPLOYEE_BONUS_HISTORY_REPORT_LIST";
export const SET_BONUS_COMPARATIVE_REPORT_LIST = "SET_BONUS_COMPARATIVE_REPORT_LIST";
export const UNSET_BONUS_COMPARATIVE_REPORT_LIST = "UNSET_BONUS_COMPARATIVE_REPORT_LIST";
export const SET_BONUS_AGING_REPORT_LIST = "SET_BONUS_AGING_REPORT_LIST";
export const UNSET_BONUS_AGING_REPORT_LIST = "UNSET_BONUS_AGING_REPORT_LIST";
export const SET_BONUS_TREND_REPORT_LIST = "SET_BONUS_TREND_REPORT_LIST";
export const UNSET_BONUS_TREND_REPORT_LIST = "UNSET_BONUS_TREND_REPORT_LIST";


//===================== Documents Module ==============================

//Folder
export const SET_DOCUMENTS_FOLDER_LIST = "SET_DOCUMENTS_FOLDER_LIST";
export const UNSET_DOCUMENTS_FOLDER_LIST = "UNSET_DOCUMENTS_FOLDER_LIST";

//File
export const SET_DOCUMENTS_FILE_LIST = "SET_DOCUMENTS_FILE_LIST"
export const UNSET_DOCUMENTS_FILE_LIST = "UNSET_DOCUMENTS_FILE_LIST"

//Recent
export const SET_DOCUMENTS_RECENT_LIST = "SET_DOCUMENTS_RECENT_LIST";
export const UNSET_DOCUMENTS_RECENT_LIST = "UNSET_DOCUMENTS_RECENT_LIST";

//Starred
export const SET_DOCUMENTS_STARRED_LIST = "SET_DOCUMENTS_STARRED_LIST";
export const UNSET_DOCUMENTS_STARRED_LIST = "UNSET_DOCUMENTS_STARRED_LIST";

//Archive
export const SET_DOCUMENTS_ARCHIVE_LIST = "SET_DOCUMENTS_ARCHIVE_LIST";
export const UNSET_DOCUMENTS_ARCHIVE_LIST = "UNSET_DOCUMENTS_ARCHIVE_LIST";

//Trash
export const SET_DOCUMENTS_TRASH_LIST = "SET_DOCUMENTS_TRASH_LIST";
export const UNSET_DOCUMENTS_TRASH_LIST = "UNSET_DOCUMENTS_TRASH_LIST";

//Share
export const SET_SHARED_USERS_LIST = "SET_SHARED_USERS_LIST";
export const UNSET_SHARED_USERS_LIST = "UNSET_SHARED_USERS_LIST";

export const SET_SHARED_WITH_ME_LIST = "SET_SHARED_WITH_ME_LIST";
export const UNSET_SHARED_WITH_ME_LIST = "UNSET_SHARED_WITH_ME_LIST";

//===================== LC Management Module ==============================
// Currency
export const SET_CURRENCY_LIST = "SET_CURRENCY_LIST";
export const UNSET_CURRENCY_LIST = "UNSET_CURRENCY_LIST";

// LC Banks
export const SET_LC_BANK_LIST = "SET_LC_BANK_LIST";
export const UNSET_LC_BANK_LIST = "UNSET_LC_BANK_LIST";
export const SET_LC_BANK_DETAIL = "SET_LC_BANK_DETAIL";
export const UNSET_LC_BANK_DETAIL = "UNSET_LC_BANK_DETAIL";

// LC Payment Terms
export const SET_LC_PAYMENT_TERM_LIST = "SET_LC_PAYMENT_TERM_LIST";
export const UNSET_LC_PAYMENT_TERM_LIST = "UNSET_LC_PAYMENT_TERM_LIST";

// LC Incoterm
export const SET_LC_INCOTERM_LIST = "SET_LC_INCOTERM_LIST";
export const UNSET_LC_INCOTERM_LIST = "UNSET_LC_INCOTERM_LIST";

// LC Types
export const SET_LC_TYPE_LIST = "SET_LC_TYPE_LIST";
export const UNSET_LC_TYPE_LIST = "UNSET_LC_TYPE_LIST";

// LC Ports
export const SET_LC_PORT_LIST = "SET_LC_PORT_LIST";
export const UNSET_LC_PORT_LIST = "UNSET_LC_PORT_LIST";

// LC Shipping Methods
export const SET_LC_SHIPPING_METHOD_LIST = "SET_LC_SHIPPING_METHOD_LIST";
export const UNSET_LC_SHIPPING_METHOD_LIST = "UNSET_LC_SHIPPING_METHOD_LIST";

export const SET_LC_DOCUMENT_TYPE_LIST = "SET_LC_DOCUMENT_TYPE_LIST";
export const UNSET_LC_DOCUMENT_TYPE_LIST = "UNSET_LC_DOCUMENT_TYPE_LIST";

// LC Exchange Rate
export const SET_LC_EXCHANGE_RATE_LIST = "SET_LC_EXCHANGE_RATE_LIST";
export const UNSET_LC_EXCHANGE_RATE_LIST = "UNSET_LC_EXCHANGE_RATE_LIST";

// LC Import - Proforma Invoice (PI)
export const SET_LC_IMPORT_PI_LIST = "SET_LC_IMPORT_PI_LIST";
export const UNSET_LC_IMPORT_PI_LIST = "UNSET_LC_IMPORT_PI_LIST";
export const SET_EDITING_LC_IMPORT_PI = "SET_EDITING_LC_IMPORT_PI";
export const UNSET_EDITING_LC_IMPORT_PI = "UNSET_EDITING_LC_IMPORT_PI";

// LC Import - LC Master
export const SET_LC_IMPORT_LC_MASTER_LIST = "SET_LC_IMPORT_LC_MASTER_LIST";
export const UNSET_LC_IMPORT_LC_MASTER_LIST = "UNSET_LC_IMPORT_LC_MASTER_LIST";
export const SET_EDITING_LC_IMPORT_LC_MASTER = "SET_EDITING_LC_IMPORT_LC_MASTER";
export const UNSET_EDITING_LC_IMPORT_LC_MASTER = "UNSET_EDITING_LC_IMPORT_LC_MASTER";

// LC Import - LC Amendment
export const SET_LC_IMPORT_LC_AMENDMENT_LIST = "SET_LC_IMPORT_LC_AMENDMENT_LIST";
export const UNSET_LC_IMPORT_LC_AMENDMENT_LIST = "UNSET_LC_IMPORT_LC_AMENDMENT_LIST";
export const SET_EDITING_LC_IMPORT_LC_AMENDMENT = "SET_EDITING_LC_IMPORT_LC_AMENDMENT";
export const UNSET_EDITING_LC_IMPORT_LC_AMENDMENT = "UNSET_EDITING_LC_IMPORT_LC_AMENDMENT";

// LC Import - LC Shipment
export const SET_LC_IMPORT_LC_SHIPMENT_LIST = "SET_LC_IMPORT_LC_SHIPMENT_LIST";
export const UNSET_LC_IMPORT_LC_SHIPMENT_LIST = "UNSET_LC_IMPORT_LC_SHIPMENT_LIST";
export const SET_EDITING_LC_IMPORT_LC_SHIPMENT = "SET_EDITING_LC_IMPORT_LC_SHIPMENT";
export const UNSET_EDITING_LC_IMPORT_LC_SHIPMENT = "UNSET_EDITING_LC_IMPORT_LC_SHIPMENT";

// LC Import - GRN
export const SET_LC_IMPORT_GNR_LIST = "SET_LC_IMPORT_GNR_LIST";
export const UNSET_LC_IMPORT_GNR_LIST = "UNSET_LC_IMPORT_GNR_LIST";
export const SET_EDITING_LC_IMPORT_GNR = "SET_EDITING_LC_IMPORT_GNR";
export const UNSET_EDITING_LC_IMPORT_GNR = "UNSET_EDITING_LC_IMPORT_GNR";
export const SET_RECEIVABLE_LC_IMPORT_GNR_LIST = "SET_RECEIVABLE_LC_IMPORT_GNR_LIST";
export const UNSET_RECEIVABLE_LC_IMPORT_GNR_LIST = "UNSET_RECEIVABLE_LC_IMPORT_GNR_LIST";

// LC Import - LC Costing
export const SET_LC_IMPORT_LC_COSTING_LIST = "SET_LC_IMPORT_LC_COSTING_LIST";
export const UNSET_LC_IMPORT_LC_COSTING_LIST = "UNSET_LC_IMPORT_LC_COSTING_LIST";
export const SET_EDITING_LC_IMPORT_LC_COSTING = "SET_EDITING_LC_IMPORT_LC_COSTING";
export const UNSET_EDITING_LC_IMPORT_LC_COSTING = "UNSET_EDITING_LC_IMPORT_LC_COSTING";
// LC Export - Documents
export const SET_LC_EXPORT_DOCUMENT_LIST = "SET_LC_EXPORT_DOCUMENT_LIST";
export const UNSET_LC_EXPORT_DOCUMENT_LIST = "UNSET_LC_EXPORT_DOCUMENT_LIST";

// LC Import - Documents
export const SET_LC_IMPORT_DOCUMENT_LIST = "SET_LC_IMPORT_DOCUMENT_LIST";
export const UNSET_LC_IMPORT_DOCUMENT_LIST = "UNSET_LC_IMPORT_DOCUMENT_LIST";


//===================== Projects module ==============================

// Settings
export const SET_PROJECT_AUTHOR_LIST = "SET_PROJECT_AUTHOR_LIST";
export const UNSET_PROJECT_AUTHOR_LIST = "UNSET_PROJECT_AUTHOR_LIST";

// activity 
export const SET_PROJECT_ACTIVITY_LIST = "SET_PROJECT_ACTIVITY_LIST";
export const UNSET_PROJECT_ACTIVITY_LIST = "UNSET_PROJECT_ACTIVITY_LIST";

// sub-activity 
export const SET_PROJECT_SUB_ACTIVITY_LIST = "SET_PROJECT_SUB_ACTIVITY_LIST";
export const UNSET_PROJECT_SUB_ACTIVITY_LIST = "UNSET_PROJECT_SUB_ACTIVITY_LIST";

//contacted by
export const SET_PROJECT_CONTACT_LIST = "SET_PROJECT_CONTACT_LIST";
export const UNSET_PROJECT_CONTACT_LIST = "UNSET_PROJECT_CONTACT_LIST";
// Project Type
export const SET_PROJECT_TYPE_LIST = "SET_PROJECT_TYPE_LIST";
export const UNSET_PROJECT_TYPE_LIST = "UNSET_PROJECT_TYPE_LIST";
// Project Theme
export const SET_PROJECT_THEME_LIST = "SET_PROJECT_THEME_LIST";
export const UNSET_PROJECT_THEME_LIST = "UNSET_PROJECT_THEME_LIST";
// Project Template
export const SET_PROGRESS_TEMPLATE_LIST = "SET_PROGRESS_TEMPLATE_LIST";
export const UNSET_PROGRESS_TEMPLATE_LIST = "UNSET_PROGRESS_TEMPLATE_LIST";
//project
export const SET_PROJECT_LIST = "SET_PROJECT_LIST";
export const UNSET_PROJECT_LIST = "UNSET_PROJECT_LIST";

// Project Budget
export const SET_PROJECT_BUDGET_LIST = 'SET_PROJECT_BUDGET_LIST';
export const UNSET_PROJECT_BUDGET_LIST = 'UNSET_PROJECT_BUDGET_LIST';

export const SET_BUDGET_COST_LIST = 'SET_BUDGET_COST_LIST';
export const UNSET_BUDGET_COST_LIST = 'UNSET_BUDGET_COST_LIST';

export const SET_PROJECT_BUDGET_REVISION_LIST = 'SET_PROJECT_BUDGET_REVISION_LIST';
export const UNSET_PROJECT_BUDGET_REVISION_LIST = 'UNSET_PROJECT_BUDGET_REVISION_LIST';

// Project Module
export const SET_PROJECT_TRAINING_LIST = "SET_PROJECT_TRAINING_LIST";
export const UNSET_PROJECT_TRAINING_LIST = "UNSET_PROJECT_TRAINING_LIST";


//===================== Resource module ==============================

// Purpose
export const SET_PURPOSE_LIST = "SET_PURPOSE_LIST";
export const UNSET_PURPOSE_LIST = "UNSET_PURPOSE_LIST";


// ========================== CMS Module =============================

// Pages
export const SET_CMS_FOLDER_LIST = "SET_CMS_FOLDER_LIST";
export const UNSET_CMS_FOLDER_LIST = "UNSET_CMS_FOLDER_LIST";

export const SET_CMS_DOCUMENT_LIST = "SET_CMS_DOCUMENT_LIST";
export const UNSET_CMS_DOCUMENT_LIST = "UNSET_CMS_DOCUMENT_LIST";

